<template>
  <div class="row">
    <div class="col-xs-12 customersearch-item customer">
      <div class="panel panel-default" v-on:click="selectCustomer" v-if="customer">
        <div :class="headingClass"><span>{{ customer.name }}</span><button class="btn btn-success btn-xs pull-right">{{ selected ? _('Deselect') : _('Select') }}</button></div>
        <div class="panel-body">
          <div class="row"> 
            <div class="col-md-6 col-xs-12">
              <template v-if="customer.email">{{ customer.email }}<br /></template>
              <template v-if="customer.phone">{{ customer.phone }}<br /></template>
              <a href="javascript:;" v-on:click.stop="editCustomer">{{ _('Edit') }}</a>
            </div>
            <div class="col-md-6 col-xs-12">
              <template v-if="customer.address">{{ customer.address }}<br /></template>
              <template v-if="customer.zip || customer.city">{{ customer.zip }} {{ customer.city}}<br /></template>
              <template v-if="customer.country">{{ customer.country }}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { CustomerDetails } from '#components'
import modals from '~/lib/modals'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'customer', 'selected'],
  mixins: [modals],
  computed: {
    headingClass () {
      return 'panel-heading' + (this.selected ? ' panel-selected' : '')
    }
  },
  methods: {
    selectCustomer () {
      if (this.selected) {
        this.$emit('selectCustomer', null)
      } else {
        this.$emit('selectCustomer', this.customer)
      }
    },
    editCustomer () {
      this.showModal('customerdetails', CustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              customer: this.customer,
              modal: true
            }
          }
        },
        events: {
          save: this.customerSaved
        },
        handlers: {},
        width: 1000
      })
    },
    customerSaved (customer) {
      // No need to do anything
    }
  },
  components: {
    CustomerDetails
  }
}
</script>
